import React from 'react';
import { Icon, BlockChooser } from '@plone/volto/components';
import { buildStyleClassNamesFromData } from '@plone/volto/helpers';
import { Button } from 'semantic-ui-react';
import includes from 'lodash/includes';
import isBoolean from 'lodash/isBoolean';
import { defineMessages, injectIntl } from 'react-intl';
import cx from 'classnames';
import config from '@plone/volto/registry';
import { doesNodeContainClick } from 'semantic-ui-react/dist/commonjs/lib';

import dragSVG from '@plone/volto/icons/drag.svg';
import addSVG from '@plone/volto/icons/circle-plus.svg';
import trashSVG from '@plone/volto/icons/delete.svg';

const messages = defineMessages({
  unknownBlock: {
    id: 'Unknown Block',
    defaultMessage: 'Unknown Block {block}',
  },
  delete: {
    id: 'delete',
    defaultMessage: 'delete',
  },
});

class EditBlockWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addNewBlockOpened: false,
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (e) => {
    if (
      this.blockNode.current &&
      doesNodeContainClick(this.blockNode.current, e)
    )
      return;

    if (this.state.addNewBlockOpened) {
      this.setState({
        addNewBlockOpened: false,
      });
      return true;
    }
  };

  blockNode = React.createRef();

  render() {
    const { intl, blockProps, draginfo, extraControls, disabled, children } =
      this.props;

    const {
      allowedBlocks,
      block,
      data,
      onSelectBlock,
      onDeleteBlock,
      onMutateBlock,
      onInsertBlock,
      selected,
    } = blockProps;
    const type = data['@type'];
    const dragVisible = !data.fixed;
    const visible = selected;

    const required = isBoolean(data.required)
      ? data.required
      : includes(config.blocks.requiredBlocks, type);

    const styles = buildStyleClassNamesFromData(data.styles);

    // Get editing instructions from block settings or props
    let instructions = data?.instructions?.data || data?.instructions;
    if (!instructions || instructions === '<p><br/></p>') {
      instructions = '';
    }

    return (
      /* START CUSTOMIZATION */
      <div style={{ position: 'relative' }} ref={this.blockNode}>
        {/* END CUSTOMIZATION */}
        <div
          ref={draginfo?.innerRef}
          {...(selected ? draginfo?.draggableProps : null)}
          className={cx(`block-editor-${data['@type']}`, styles, {
            [data.align]: data.align,
          })}
        >
          {(!selected || !visible || disabled) && (
            <div
              style={{
                display: 'none',
                // keep react-beautiful-dnd happy
              }}
              {...draginfo.dragHandleProps}
            ></div>
          )}
          {visible && (
            /* START CUSTOMIZATION
            <div className="block-toolbar">*/
            <>
              {/* END CUSTOMIZATION */}
              {instructions ? extraControls : ''}

              {!disabled && (
                <>
                  <div
                    style={{
                      display: dragVisible ? 'inline-block' : 'none',
                    }}
                    {...draginfo.dragHandleProps}
                    /* START CUSTOMIZATION */
                    className="drag handle wrapper wrapper-group-block"
                    /* END CUSTOMIZATION */
                  >
                    <Button icon basic title="Drag and drop">
                      <Icon name={dragSVG} size="19px" />
                    </Button>
                  </div>

                  {
                    /* START CUSTOMIZATION !disableNewBlocks && !blockHasValue(data) && */ <Button
                      icon
                      basic
                      title="Add block"
                      onClick={() => {
                        this.setState((prevState) => ({
                          addNewBlockOpened: !prevState.addNewBlockOpened,
                        }));
                      }}
                      className="group-block-add-button ui basic icon button block-add-button new-add-block"
                    >
                      <Icon name={addSVG} className="" size="24px" />
                    </Button> /* END CUSTOMIZATION */
                  }
                  {!required && (
                    <Button
                      icon
                      basic
                      title="Remove block"
                      onClick={() => onDeleteBlock(block)}
                      /* START CUSTOMIZATION */
                      className="delete-button-group-block ui basic icon button delete-button"
                      /* END CUSTOMIZATION */
                      aria-label={intl.formatMessage(messages.delete)}
                    >
                      <Icon name={trashSVG} size="19px" />
                    </Button>
                  )}
                  {this.state.addNewBlockOpened && (
                    /* START CUSTOMIZATION */
                    <div
                      style={{
                        position: 'absolute',
                        top: '100%',
                        left: '50%',
                        marginTop: '24px',
                        transform: 'translateX(-50%)',
                        zIndex: 1000,
                      }}
                    >
                      {/* END CUSTOMIZATION */}
                      <BlockChooser
                        onMutateBlock={(id, value) => {
                          onMutateBlock(id, value);
                          this.setState({ addNewBlockOpened: false });
                        }}
                        onInsertBlock={(id, value) => {
                          onSelectBlock(onInsertBlock(id, value));
                          this.setState({ addNewBlockOpened: false });
                        }}
                        currentBlock={block}
                        allowedBlocks={allowedBlocks}
                      />
                      {/* START CUSTOMIZATION */}
                    </div>
                    /* END CUSTOMIZATION */
                  )}
                </>
              )}
              {/* START CUSTOMIZATION
            </div> */}
            </>
            /* END CUSTOMIZATION */
          )}

          <div
            className={cx('ui drag block wrapper inner', type, {
              multiSelected: this.props.multiSelected,
            })}
          >
            {children}
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(EditBlockWrapper);
